$(document).ready(function() {

	// intersection observer for sections
	var observer = new IntersectionObserver(entries => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				$(entry.target).addClass('js-watcher-active');
			}
		});
	}, { rootMargin: '0px 0px -128px 0px' });

	var watchers = $('.js-watcher');
	if (watchers) {
		$(watchers).each(function(index, watcher) {
			observer.observe(watcher);
		});
	}

	// toggle mobile menu visibility
	$('#mobile-menu-trigger').on('click', function() {
		$('body').toggleClass('mobile-menu-active');
	});

	// statistics :: count up to number
	if ($('.statistic').length > 0) {
		var statistics = $('.statistic');
		$(statistics).each(function(index, statistic) {
			var target = $('.statistic-number', statistic)[0];
			var end_number = $(target).attr('data-number');
			var prefix = $(target).attr('data-prefix');
			var suffix = $(target).attr('data-suffix');
			var options = {
				startVal: 0,
				decimalPlaces: 0,
				duration: 5,
				useGrouping: true,
				useEasing: true,
				prefix: prefix,
				suffix: suffix,
				enableScrollSpy: true,
				scrollSpyOnce: true
			};
			var counter = new CountUp(target, end_number, options);
		});
	}

});
